import { Input } from "@/components";

import SettingsStep from "../Step";

const renderFormControls = ({ formState, changeFormState, FormControl }) => (
    <div>
        <div className="text">
            Now just enter the dimensions of the space. Then you&apos;ll be all
            set to create your light map-sterpiece.
        </div>
        <div className="row">
            <FormControl className="col-sm-5" name="width" required>
                <Input
                    label="Space Width (feet)"
                    value={formState.width}
                    onChange={(value) =>
                        changeFormState({
                            width: value,
                        })
                    }
                    required
                    decimalDigits={2}
                    min={0}
                    type="number"
                />
            </FormControl>
            <FormControl className="col-sm-5" name="height" required>
                <Input
                    label="Space Length (feet)"
                    value={formState.height}
                    onChange={(value) =>
                        changeFormState({
                            height: value,
                        })
                    }
                    required
                    decimalDigits={2}
                    min={0}
                    type="number"
                />
            </FormControl>
        </div>
    </div>
);

/**
 * Wizard step for the space dimensions and offsets.
 *
 * @param props - The settings step props, forwarded verbatim.
 * @returns The rendered space step.
 */
const SpaceStep = (props) => (
    <SettingsStep {...props} renderFormControls={renderFormControls} />
);

export default SpaceStep;
